/* src/app/views/admin/message/message.component.css */
::ng-deep .p-autocomplete-input {
  border-radius: 0.25rem;
  width: 375px;
  padding: 0.75rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  border: 1px solid rgba(212, 212, 216, 1);
}
::ng-deep p-paginator svg {
  transform: rotate(180deg);
}
/*# sourceMappingURL=message.component.css.map */
